import svg4everybody from 'svg4everybody';
require('es6-promise').polyfill();

import './partials/global/logoAnimation';
import './partials/global/logoAnimationLegacy';
import './partials/global/languageSwitcher';
import './partials/global/languageSwitcherMobile';
import './partials/addSalesForceButtonScript';
import './partials/handleDataAttributes';
import './partials/handleDataAttributesMobile';
import './partials/handleMobileSublevels';
import './partials/handleFaqRubriek';
import './partials/handleCompanyinformation';
import './partials/handleFaqRubriekMobile';
import './partials/handleFaqRubriekMobileSubitem';
import './partials/handleMobileSublevelsLegacy';
import './partials/handleTopicActions';
import './partials/handleMobileTabContent';
import './partials/handleMobileTabContentLegacy';
import './partials/handleTabContent';
import './partials/toggleMobileNav';
import './partials/toggleDropdown';
import './partials/flexibleContactForm';
import './partials/selectURIChange';
import './partials/customSelect';
import './partials/autocompleteCompanyInput';
import './partials/contactFormCompanyInput';
import './partials/gravityFormsCompanyInput';
import './partials/disableButtonOnFormSubmit';
import './partials/initYouTube';
import './partials/initVimeo';
import './partials/quoteSlider';
import './partials/addDataLayers';
import './partials/blog/refreshPopularPosts';
import './partials/videos/filterVideos';
import './partials/videos/videos';
import './partials/wikiMobileNav';
import './partials/forms/contactForm';
import './partials/forms/blockCommonEmailDomains';
import './partials/forms/honeypot';
import './partials/filterCases';
import './partials/pluginsFilter';
import './partials/apisFilter';
import './partials/onboarding-advisor';
import './partials/tooltips';

svg4everybody();
